/* tslint:disable */
import {
  StockProductionLot,
  StockQuantPackage,
  ManufacturingProductionOrderLine
} from '../index';

declare var Object: any;
export interface LotConfigurationMpoLineInterface {
  "id"?: number;
  "mpo_line_id"?: number;
  "prod_lot_id"?: number;
  "package_ids"?: any;
  "production_qty_by_shift"?: number;
  prodLot?: StockProductionLot;
  inLocation?: StockQuantPackage[];
  mpoLine?: ManufacturingProductionOrderLine;
}

export class LotConfigurationMpoLine implements LotConfigurationMpoLineInterface {
  "id": number;
  "mpo_line_id": number;
  "prod_lot_id": number;
  "package_ids": any;
  "production_qty_by_shift": number;
  prodLot: StockProductionLot;
  inLocation: StockQuantPackage[];
  mpoLine: ManufacturingProductionOrderLine;
  constructor(data?: LotConfigurationMpoLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LotConfigurationMpoLine`.
   */
  public static getModelName() {
    return "LotConfigurationMpoLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LotConfigurationMpoLine for dynamic purposes.
  **/
  public static factory(data: LotConfigurationMpoLineInterface): LotConfigurationMpoLine{
    return new LotConfigurationMpoLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LotConfigurationMpoLine',
      plural: 'LotConfigurationMpoLines',
      path: 'LotConfigurationMpoLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "mpo_line_id": {
          name: 'mpo_line_id',
          type: 'number'
        },
        "prod_lot_id": {
          name: 'prod_lot_id',
          type: 'number'
        },
        "package_ids": {
          name: 'package_ids',
          type: 'any'
        },
        "production_qty_by_shift": {
          name: 'production_qty_by_shift',
          type: 'number'
        },
      },
      relations: {
        prodLot: {
          name: 'prodLot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'prod_lot_id',
          keyTo: 'id'
        },
        inLocation: {
          name: 'inLocation',
          type: 'StockQuantPackage[]',
          model: 'StockQuantPackage',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'package_ids'
        },
        mpoLine: {
          name: 'mpoLine',
          type: 'ManufacturingProductionOrderLine',
          model: 'ManufacturingProductionOrderLine',
          relationType: 'belongsTo',
                  keyFrom: 'mpo_line_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LotConfigurationMpoLine.ts